var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93904 3.08354L6.38189 3.21211C6.43235 3.4317 6.43866 3.65912 6.40045 3.88117C6.36223 4.10321 6.28026 4.31544 6.1593 4.50553C6.03834 4.69561 5.8808 4.85975 5.69584 4.98841C5.51087 5.11707 5.30218 5.20768 5.08189 5.25497C4.6352 5.34894 4.16946 5.2639 3.78479 5.01814C3.40012 4.77238 3.12722 4.38551 3.02475 3.94068L1.91047 4.16926C1.75766 4.2026 1.61319 4.26657 1.4858 4.35732C1.35841 4.44806 1.25074 4.56368 1.16929 4.69721C1.08784 4.83073 1.0343 4.97938 1.01191 5.13418C0.989528 5.28897 0.998755 5.4467 1.03904 5.59783C1.03904 5.59783 1.55332 7.98354 2.15332 10.6693",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6533 3.06926C17.5679 3.30981 17.4346 3.53052 17.2614 3.71802C17.0883 3.90552 16.8788 4.05592 16.6458 4.16009C16.4128 4.26426 16.1611 4.32005 15.9058 4.32406C15.6506 4.32807 15.3973 4.28023 15.1611 4.18344C14.9249 4.08665 14.7108 3.94291 14.5318 3.76095C14.3529 3.57898 14.2127 3.36257 14.1198 3.12483C14.0269 2.88709 13.9832 2.63297 13.9915 2.37786C13.9997 2.12275 14.0596 1.87196 14.1676 1.64069L13.0105 1.09783C12.7015 0.969066 12.3542 0.967348 12.0439 1.09305C11.7337 1.21875 11.4855 1.46173 11.3533 1.76926L6.55331 13.0693L5.92474 14.4978C5.79597 14.8068 5.79425 15.1541 5.91995 15.4644C6.04566 15.7746 6.28864 16.0228 6.59617 16.155L12.3962 18.6264C12.7052 18.7552 13.0525 18.7569 13.3627 18.6312C13.6729 18.5055 13.9211 18.2625 14.0533 17.955L19.4819 5.18355C19.6016 4.88656 19.6048 4.55535 19.4909 4.25608C19.377 3.95682 19.1544 3.71154 18.8676 3.56926L17.6533 3.06926Z",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.3acd978392ad0be035ca24622d2c1da7.svg";
export { ForwardRef as ReactComponent };